module.exports = __webpack_public_path__ + "book-preview.7e057d9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/book-preview.png
// module id = zpjC
// module chunks = 0